import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../context/AuthContext';
import { useMemo } from 'react';

const useDynamicModules = () => {
  const { authData } = useAuth();

  /* 1 · enabled?  ------------------------------------------------- */
  const enabled = useMemo(() => {
    const ok = !!authData?.token && !!authData?.roleId && !!authData?.hotelId;
    //console.log('[modules] enabled =', ok, '| authData=', {
     // token: !!authData?.token,
     // roleId: authData?.roleId,
     // hotelId: authData?.hotelId,
   // });
    return ok;
  }, [authData]);

  /* 2 · fetch ------------------------------------------------------ */
  return useQuery({
    queryKey: ['modules', authData?.roleId, authData?.hotelId],
    enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const rawRole =
        typeof authData.role === 'string'
          ? authData.role
          : Array.isArray(authData.role)
          ? authData.role[0]
          : '';
      const roleSegment = rawRole ? `/${rawRole.toLowerCase()}` : '';

      const url = `/modules/my-routes/${authData.roleId}/${authData.hotelId}${roleSegment}`;
      //console.log('[modules] GET', url);

      const res = await axiosInstance.get(url);
      //console.log('[modules] raw response:', res.data);

      // ← adjust here if API returns { routes:[…] } instead of pure array
      return Array.isArray(res.data) ? res.data : [];
    },
    onError: err => console.error('[modules] fetch failed', err),
    initialData: [],
  });
};

export default useDynamicModules;
